import PercentageToggleContainer from './containers/PercentageToggleContainer';

export default PercentageToggleContainer;
